document.addEventListener("DOMContentLoaded", () => {

    setTimeout(function () {
        $('.identixweb-order-delivery').appendTo('.carrito .botones .container-app');
    }, 2000);

    // console.log('script cargado. Tortas en cart: ' + window.sizeTortas);

    const handleCalendar = (calendarEnabled = true) => {

        const countCakes = window.sizeTortas;
        const appSelector = ".container-app";
        const container = document.querySelector(appSelector);

        Promise.all([
            waitLoadCalendarModule(appSelector),
            getCurrentDate()
        ])
            .then((res) => {
                const appContainer = res[0];
                const currentDate = res[1];
                if (countCakes != 0) {
                    // cuando las promesas fueron resueltas, manejar eventos.
                    container.addEventListener("click", (event) => {
                        const calendarInput = event.target.closest('.identixweb-order-delivery-datepicer-icon');

                        if (calendarInput) {
                            blockDays(currentDate.year, currentDate.month, currentDate.day, currentDate.dow, 1);
                        }
                    });
                }
            })
            .finally(() => {
                if (calendarEnabled == false) { // desactivamos calendario
                    container.style.display = "none";
                    container.dataset.calendarDelivery = false;
                    return;
                }
                container.dataset.calendarDelivery = true;
                console.log(`calendar Enabled ${calendarEnabled}`)
            });
    }

    const blockDays = (currentYear, currentMonth, currentDay, dow, deadLine) => {
        // obtener número de días del mes
        const numDaysMonth = (y, m) => new Date(y, m, 0).getDate();
        const daysToEndCurrentMonth = numDaysMonth(currentYear, currentMonth) - currentDay;

        setTimeout(() => {
            // Datos del calendario en viewport
            const DOMcalendarDateString = document.querySelector('.container-app .rmdp-header-values').textContent;
            const DOMcalendarMonth = turnStringToDate(DOMcalendarDateString).getMonth() + 1;
            const DOMcalendarYear = turnStringToDate(DOMcalendarDateString).getFullYear();

            const calendarDays = document.querySelectorAll('.rmdp-wrapper .rmdp-day');
            var calendarEnabledDays = Array.from(calendarDays).filter((day) => !day.classList.contains("rmdp-disabled"));
            calendarEnabledDays = Array.from(calendarEnabledDays).filter((day) => !day.classList.contains("rmdp-day-hidden"));

            var finalDeadLine = deadLine;

            if (dow >= 4) {
                finalDeadLine = deadLine + 1;
            }

            if (currentYear != DOMcalendarYear || currentMonth != DOMcalendarMonth) {
                console.log("diff")
                console.log(calendarEnabledDays.length)
                return;
            }

            calendarEnabledDays.forEach((ele) => {
                if (ele.textContent <= currentDay + finalDeadLine) {
                    ele.classList.add('rmdp-disabled');
                    ele.style.pointerEvents = "none";
                }
            })

        }, 20);
    }

    const getCurrentDate = async () => {
        const country = "America/Santiago";
        const url = `https://worldtimeapi.org/api/timezone/${country}`;
        try {
            const res = await fetch(url);

            if (!res.ok) {
                throw new Error("nope");
            }

            const data = await res.json();

            const currentDate = {
                'year': new Date(data.utc_datetime).getFullYear(),
                'month': new Date(data.utc_datetime).getMonth() + 1,
                'day': new Date(data.utc_datetime).getDate(),
                'hour': new Date(data.utc_datetime).getHours(),
                'dow': data.day_of_week // day of week
            }

            return currentDate;

        } catch (err) {
            console.error(err)
        }
    }

    const waitLoadCalendarModule = (selector) => {
        return new Promise((resolve, reject) => {

            const div = document.querySelector(selector);
            // Verificar si el div existe
            if (!div) {
                reject(new Error(`No se encontró un elemento con el ID ${selector}`));
                return;
            }
            // Verificar si el contenido ya está cargado
            if (div.childElementCount > 0) {
                resolve('app container cargado');
            } else {
                // Esperar a que el contenido se cargue
                const observer = new MutationObserver(() => {
                    if (div.childElementCount > 0) {
                        observer.disconnect(); // Detener la observación una vez que el contenido está cargado
                        resolve('app container cargado');
                    }
                });
                // Configurar el observador para vigilar cambios en el div
                observer.observe(div, { childList: true, subtree: true });
            }
        });
    }

    const turnStringToDate = (fechaString) => {
        // Dividir la cadena en mes y año
        const partes = fechaString.split(',');
        const mesString = partes[0];
        const añoString = partes[1];
        // Mapear el nombre del mes a su número correspondiente
        const meses = [
            'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
            'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
        ];
        const numeroMes = meses.findIndex(mes => mes === mesString) + 1;
        // Construir el objeto Date
        const fecha = new Date(`${numeroMes}/01/${añoString}`);

        return fecha;
    }

    handleCalendar(false);

});